<template>
  <div>
    <div class="login-top">
      <img class="title_img" src="~@/assets/title.png" alt="" />
    </div>
    <div class="login-page">
      <div class="_loading" v-show="isloading"></div>
      <div class="login-main-container" v-show="!isloading">
        <div>
          <img class="login-main" src="~@/assets/bg2.png" alt="" />
        </div>
        <div class="login-container">
          <el-row class="login-content-container">
            <!-- <el-col :span="10">
              <div class="system-logo-container">
                <img src="../../static/img/dl.png" alt="" class="system-logo"  style="width:140px;height:auto;">
              </div>
            </el-col>-->
            <el-col :span="23" class="right-ruleForm-container">
              <div class="system-title" style="align-items: center; justify-content: center">
                <!-- <span class="left-line"></span> -->
                <img class="user1" src="~@/assets/user2.png" alt="" />
                <span>欢迎登录</span>
              </div>
              <div class="change_login">
                <!-- <span class="left-line"></span> -->
                <div class="zhanghao_login" style="cursor: pointer" :style="loginShow == false ? 'background-color: #2494f2;color: #FFFFFF;' : ''" @click="showLogin(1)">账号登录</div>
                <div class="zhanghao_login" style="cursor: pointer" :style="loginShow == true ? 'background-color: #2494f2;color: #FFFFFF;' : ''" @click="showLogin(2)">手机登录</div>
              </div>

              <el-form v-show="!loginShow" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0" class="login-ruleForm">
                <el-form-item label prop="userName" style="margin-bottom: 20px">
                  <el-input @keyup.enter.native="submitForm('ruleForm')" v-model="ruleForm.userName" placeholder="请输入账号" prefix-icon="el-icon-user" :maxlength="20" @change="filteremojifun($event, 'userName', 'ruleForm')">
                    <!-- <img src="~@/assets/user 2@2x.png" alt=""> -->
                  </el-input>
                </el-form-item>
                <el-form-item label prop="pwd" style="margin-bottom: 20px">
                  <span :class="'showOrhide_pwdIcon ' + showOrhide_pwdIcon" @click="showpsd()"></span>
                  <el-input @keyup.enter.native="submitForm('ruleForm')" v-model="ruleForm.pwd" :type="pwdType" placeholder="请输入密码" prefix-icon="el-icon-tickets" :maxlength="20" @change="filteremojifun($event, 'pwd', 'ruleForm')"></el-input>
                </el-form-item>
                <el-radio @input="changeType" style="margin-right: 15px; margin-bottom: 20px" v-model="switchType" :label="0">云平台</el-radio>
                <el-radio @input="changeType" v-model="switchType" :label="1">私有</el-radio>

                <!-- <el-form-item label prop class="rememberPassword-container" style="margin-bottom: 10px">
                  <el-checkbox label="记住密码" name v-model="rememberPassword"></el-checkbox>
                </el-form-item> -->
                <el-form-item>
                  <el-button class="login-btn" type="primary" style="margin-top: -5rem" @click="submitForm('ruleForm')">登录</el-button>
                </el-form-item>
              </el-form>
              <el-form v-show="loginShow" :model="phoneForm" :rules="rules" ref="ruleForm" label-width="0" class="login-ruleForm">
                <el-form-item label prop="phone" v-show="loginShow" style="margin-bottom: 20px">
                  <el-input @keyup.enter.native="submitForm('ruleForm')" v-model="phoneForm.phone" placeholder="请输入手机号" prefix-icon="el-icon-mobile-phone" :maxlength="20">
                    <!-- <img src="~@/assets/user 2@2x.png" alt=""> -->
                  </el-input>
                </el-form-item>
                <el-form-item label prop="code" v-show="loginShow" style="margin-bottom: 20px">
                  <span :class="'showOrhide_pwdIcon ' + showOrhide_pwdIcon" @click="showpsd()"></span>
                  <el-input style="width: 17rem" v-model="phoneForm.code" :type="pwdType" placeholder="请输入验证码" prefix-icon="el-icon-postcard" :maxlength="20"> </el-input>
                  <el-button v-show="yzmShow" @click="postYzm" type="primary" style="height: 3.1rem; margin-left: 0.5rem; width: 8.4rem">发送验证码</el-button>
                  <el-button type="info" v-show="!yzmShow" disabled style="height: 3.1rem; margin-left: 0.5rem; width: 8.4rem">{{ count }}秒后重新发送</el-button>
                </el-form-item>

                <el-form-item>
                  <el-button class="login-btn" type="primary" style="margin-top: 0rem" @click="phoneSubmitForm('ruleForm')">登录</el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="login-bottom">
      <div class="bottom_phone" style="display: flex; justify-content: space-around">
        <div class="left_first" style="display: flex; margin-top: 2rem; width: 27rem; justify-content: center">
          <img style="width: 4rem; height: 4rem; margin-top: 1rem" src="~@/assets/dh.png" alt="" />
          <div style="margin-top: 1.6rem">
            <div class="title">为使您的咨询问题及时得到答复，请您务必拔打以下技术支持电话：</div>
            <div class="phone">13372559097</div>
          </div>
        </div>
        <div class="left_first" style="display: flex; margin-top: 2rem; width: 27rem; justify-content: center">
          <img style="width: 4rem; height: 4rem; margin-top: 1rem" src="~@/assets/yx.png" alt="" />
          <div style="margin-top: 1.6rem">
            <div class="title">如电话繁忙请通过以下邮箱进行咨询</div>
            <div class="phone">136920113@qq.com</div>
          </div>
        </div>
        <div class="left_first" @click="goto_1423" style="display: flex; margin-top: 2rem; width: 27rem; justify-content: center">
          <img style="width: 4rem; height: 4rem; margin-top: 1rem" src="~@/assets/bz.png" alt="" />
          <div style="margin-top: 1rem">
            <div class="phone" style="margin-top: 1.2rem">产品概述</div>
          </div>
        </div>
      </div>
      <div></div>
      <div></div>
    </div>
  </div>
</template>
<script>
import { decode } from '@/utils/base64.js'
import { encode } from '@/utils/base64.js'

export default {
  name: 'login',
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入验证码'))
      } else {
        if (this.ruleForm.code.toUpperCase() !== this.codeString) {
          callback(new Error('验证码不正确'))
        }
        callback()
      }
    }
    return {
      yzmShow: true,
      timer: null,
      count: '',
      switchType: 0,
      phoneForm: {
        phone: '',
        code: ''
      },
      isloading: true,
      loginShow: false,
      project: this.$project,
      userNameIcon: 'FontFamily login-input-icon el-icon-fault-location-zhanghao1',
      pwdIcon: 'FontFamily login-input-icon el-icon-fault-location-mima',
      showOrhide_pwdIcon: 'FontFamily el-icon-fault-location-tubiao-',
      pwdType: 'password',
      rememberPassword: false,
      ruleForm: {
        userName: '',
        pwd: '',
        code: ''
      },
      rules: {
        userName: [
          { required: true, message: '请输入账号', trigger: 'blur' },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          }
        ],
        pwd: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          }
        ]
        // code: [{ required: true, validator: validatePass, trigger: "blur" }]
      },
      imgString: '',
      codeString: ''
    }
  },
  created() {
    if (this.$route.query.user) {
      this.isloading = true
    } else {
      this.isloading = false
    }
    if (window.localStorage.getItem('userNameZ') && window.localStorage.getItem('userNameZ') != null) {
      this.ruleForm.userName = window.localStorage.getItem('userNameZ')
      this.ruleForm.pwd = window.localStorage.getItem('pwdZ')
      this.rememberPassword = true
    }
    window.localStorage.removeItem('web')
    this.$forceUpdate()
  },
  mounted() {
    this._autologin1()
  },
  methods: {
    changeType() {
      if (this.switchType == 0) {
        window.localStorage.removeItem('web')
        this.$forceUpdate()
      } else {
        window.localStorage.setItem('web', 236)
        this.$forceUpdate()
      }
      console.log(this.switchType)
    },
    goto_1423() {
      window.open('https://futurefarm.bbyiot.com/agriculture_develop_webservice/static//pdf/1717037976532.pdf')
    },
    phoneSubmitForm() {
      this.$api.system.codeLogin(this.phoneForm.phone, this.phoneForm.code).then(res => {
        if (res.code == 200) {
          this.getUserDetails(res.data.id)
          this.$store.commit('user/SET_TOKEN', res.data.token)
          window.localStorage.setItem('departId', res.data.departId)
          window.localStorage.setItem('departName', res.data.departName)
          if (res.data.permissions) {
            this.$store.commit('user/SET_PERMISSION', res.data.permissions)
          }
          sessionStorage.setItem('USER_ID', res.data.id)
          sessionStorage.setItem('USER_name', res.data.username)
          sessionStorage.setItem('USER_Type', res.data.userType) // 用户类型 0 管理员 1 普通用户
          // sessionStorage.setItem("USER_encode", this.$route.query.user); // 用户名加密
          // sessionStorage.setItem("PWD_encode", this.$route.query.psd); // 密码加密

          if (res.data.userType == 3) {
            // 专家，跳转生长模式
            this.$router.push({
              name: 'growthModel'
            })
          } else {
            // 其它，跳转首页
            this.$router.push({
              name: 'homePage1'
            })
          }
        }
      })
    },
    //获取详情
    getUserDetails(id) {
      console.log(233)
      this.$api.system.getUserDetails(id).then(res => {
        if (res.code == 200) {
          console.log(res.data, 3333)
          sessionStorage.setItem('USER_groupID', res.data.groupId)
        }
      })
    },
    postYzm() {
      this.$api.system.sendCode(this.phoneForm.phone).then(res => {
        if (res.code == 200) {
          const TIME_COUNT = 60
          if (!this.timer) {
            this.count = TIME_COUNT
            this.yzmShow = false
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--
              } else {
                this.yzmShow = true
                clearInterval(this.timer)
                this.timer = null
              }
            }, 1000)
          }
        }
      })
    },
    showLogin(type) {
      if (type == 1) {
        this.loginShow = false
      } else {
        this.loginShow = true
      }
    },
    // 自动登录
    _autologin1() {
      let user = this.$route.query.user
      let pwd = this.$route.query.psd
      if (!user) {
        return false
      }

      user = decode(user)
      pwd = decode(pwd)
      pwd = this.$utils.calcuMD5(pwd)

      this.$utils.delAllStorage()
      this.$utils.delAllSession()
      this.$api.system.login(user, pwd).then(res => {
        if (res.code == 200) {
          this.getUserDetails(res.data.id)

          this.$store.commit('user/SET_TOKEN', res.data.token)
          window.localStorage.setItem('departId', res.data.departId)
          window.localStorage.setItem('departName', res.data.departName)
          if (res.data.permissions) {
            this.$store.commit('user/SET_PERMISSION', res.data.permissions)
          }
          sessionStorage.setItem('USER_ID', res.data.id)
          sessionStorage.setItem('USER_name', res.data.username)
          sessionStorage.setItem('USER_Type', res.data.userType) // 用户类型 0 管理员 1 普通用户

          sessionStorage.setItem('USER_encode', this.$route.query.user) // 用户名加密
          sessionStorage.setItem('PWD_encode', this.$route.query.psd) // 密码加密

          if (res.data.userType == 3) {
            // 专家，跳转生长模式
            this.$router.push({
              name: 'growthModel'
            })
          } else {
            // 其它，跳转首页
            this.$router.push({
              name: 'homePage1'
            })
          }
        }
      })
    },
    getCodeImg() {
      this.$api.designManagement.getCodeImg().then(res => {
        if (res.code == 200) {
          this.imgString = res.data.imgString
          this.codeString = res.data.codeString.toUpperCase()
        }
      })
    },
    getAuthority(id) {
      this.$api.system.getAiUserRoleMenus(id).then(res => {
        if (res.code == 200) {
          let datas = res.data
          let arr = []
          for (let i of datas) {
            if (i.isCheck == 1) {
              arr.push(i.code)
            }
            for (let j of i.nextMenus) {
              if (j.isCheck == 1) {
                arr.push(j.code)
              }
              for (let k of j.nextMenus) {
                if (k.isCheck == 1) {
                  arr.push(k.code)
                }
              }
            }
          }
          let arr1 = JSON.stringify(arr)
          window.localStorage.setItem('arr', arr1)
          this.$toaster.ok('登录成功')

          let userType = sessionStorage.getItem('USER_Type')
          if (userType == 3) {
            // 专家，跳转生长模式
            this.$router.push({
              name: 'growthModel'
            })
          } else {
            // 其它，跳转首页
            this.$router.push({
              name: 'homePage1'
            })
          }
        }
      })
    },
    submitForm(formName) {
      //  项目进行中 ， 退出再点击登陆，请求地址后面会拼上 token，造成返回结果为空，进而登录无反应，所以这里手动清除store里面的token
      this.$store.state.user.token = ''
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$api.system
            .login(this.ruleForm.userName, this.$utils.calcuMD5(this.ruleForm.pwd))
            .then(res => {
              if (res.code == 200) {
                var remeberFlag
                if (this.rememberPassword == true) {
                  window.localStorage.setItem('userNameZ', this.ruleForm.userName)
                  window.localStorage.setItem('pwdZ', this.ruleForm.pwd)
                  window.localStorage.setItem('autoLogin', 1)
                  window.localStorage.setItem('rememberPasswordZ', this.rememberPassword)
                }
                window.localStorage.setItem('user', this.ruleForm.userName)
                window.localStorage.setItem('pwd', this.$utils.calcuMD5(this.ruleForm.pwd))
                this.$store.commit('user/SET_TOKEN', res.data.token)
                window.localStorage.setItem('departId', res.data.departId)
                window.localStorage.setItem('departName', res.data.departName)
                if (res.data.permissions) {
                  this.$store.commit('user/SET_PERMISSION', res.data.permissions)
                }
                sessionStorage.setItem('USER_ID', res.data.id)
                sessionStorage.setItem('USER_inst', res.data.organization)
                sessionStorage.setItem('USER_name', res.data.username)
                sessionStorage.setItem('USER_Type', res.data.userType) // 用户类型（-1 超级管理员，0管理员，1测试用户，2普通用户，3专家用户）

                sessionStorage.setItem('USER_encode', encode(this.ruleForm.userName)) // 用户名加密
                sessionStorage.setItem('PWD_encode', encode(this.ruleForm.pwd)) // 密码加密

                // 权限
                this.getAuthority(res.data.id)
                this.getUserDetails(res.data.id)
              }
              this.getID()
            })
            .catch(res => {})
        }
      })
    },
    getID() {
      let data = {
        username: this.ruleForm.userName
      }
      // this.$api.system.VillageAgrilogin(data).then((res) => {
      //   window.localStorage.setItem('villageId', res.data.villageId)
      // })
    },
    showpsd() {
      // 改变密码的显示状态
      if (this.showOrhide_pwdIcon == 'FontFamily el-icon-fault-location-tubiao-') {
        this.showOrhide_pwdIcon = 'el-icon-view'
        this.pwdType = 'text'
      } else {
        this.showOrhide_pwdIcon = 'FontFamily el-icon-fault-location-tubiao-'
        this.pwdType = 'password'
      }
    },
    filteremojifun(e, name, ruleForm) {
      this.$utils.filteremojifun(this, e, name, ruleForm)
    }
  }
}
</script>
<style lang="scss" scoped>
._loading {
  width: 100px;
  height: 100px;
  padding-top: 45%;
  margin-left: 45%;
  box-sizing: border-box;
}

::v-deep .el-input__inner {
  height: 50px !important;
  line-height: 50px !important;
  font-size: 18px;
}

::v-deep .el-input__prefix {
  font-size: 18px !important;
  line-height: 51px !important;
}

.el-loading-mask {
  background: inherit !important;
}

.left_first {
  cursor: pointer;
  .title {
    min-width: 250px;
    min-height: 20px;
    font-size: 10px;
    font-family: MicrosoftYaHei;
    color: #333333;
    line-height: 14px;
  }

  .phone {
    width: 145px;
    height: 26px;
    font-size: 20px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #555555;
    line-height: 26px;
  }
}

@import '@/style/login.scss';
</style>
